module.exports = __webpack_public_path__ + "img/Edit_Line_1_12px_Icon_red.3f6829f7.svg";